import { ROUTE_PATHS } from '../routing/route-paths';

export interface NavigationItem {
  label: string;
  icon?: string;
  route?: string;
  children?: NavigationItem[];
  disabled?: boolean;
  superAdminOnly?: boolean;
}

export interface NavigationGroup {
  label: string;
  items: NavigationItem[];
}

export const appNavigationConfig: NavigationGroup[] = [
  {
    label: 'Workspace',
    items: [
      {
        label: 'Quick Access',
        icon: 'pi pi-compass',
        route: `/${ROUTE_PATHS.QUICK_ACCESS}`,
      },
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        route: `/${ROUTE_PATHS.DASHBOARD}`,
        superAdminOnly: true,
      },
    ],
  },
  {
    label: 'Identity',
    items: [
      {
        label: 'Users',
        icon: 'pi pi-users',
        route: `/${ROUTE_PATHS.USERS}`,
      },
      {
        label: 'Organizations',
        icon: 'pi pi-building',
        route: `/${ROUTE_PATHS.ORGANIZATIONS}`,
      },
      {
        label: 'Identity Providers',
        icon: 'pi pi-globe',
        route: `/${ROUTE_PATHS.IDENTITY_PROVIDERS}`,
      },
    ],
  },
  {
    label: 'Platform Management',
    items: [
      {
        label: 'Clients',
        icon: 'pi pi-key',
        route: `/${ROUTE_PATHS.OAUTH_CLIENTS}`,
      },
    ],
  },
  {
    label: 'Access Management',
    items: [
      {
        label: 'Platform Access',
        icon: 'pi pi-verified',
        route: `/${ROUTE_PATHS.PLATFORM_ACCESS}`,
      },
      {
        label: 'API Access',
        icon: 'pi pi-sitemap',
        route: `/${ROUTE_PATHS.API_ACCESS}`,
      },
      {
        label: 'Platform Roles',
        icon: 'pi pi-shield',
        route: `/${ROUTE_PATHS.ROLES}`,
      },
    ],
  },
  {
    label: 'Monitoring & Security',
    items: [
      {
        label: 'Security Settings',
        icon: 'pi pi-lock',
        route: `/${ROUTE_PATHS.SECURITY}`,
      },
      {
        label: 'Signing Keys',
        icon: 'pi pi-key',
        route: `/${ROUTE_PATHS.SIGNING_KEYS}`,
      },
      {
        label: 'OIDC Operations',
        icon: 'pi pi-globe',
        route: `/${ROUTE_PATHS.OIDC_OPERATIONS}`,
      },
      {
        label: 'Audit Activity',
        icon: 'pi pi-history',
        route: `/${ROUTE_PATHS.ACTIVITY_LOGS}`,
      },
      {
        label: 'Security Events',
        icon: 'pi pi-shield',
        route: `/${ROUTE_PATHS.SECURITY_EVENTS}`,
      },
    ],
  },
  {
    label: 'Account',
    items: [
      {
        label: 'My Profile',
        icon: 'pi pi-user',
        route: `/${ROUTE_PATHS.PROFILE}`,
      },
    ],
  },
];
